module.exports = __webpack_public_path__ + "images/content-personal.597875c9b28a294d7769a54d4ce69e7e.svg";